import { Injectable } from '@angular/core';
import { PortalLoginResult } from './api.service';

const SESSION_KEY = 'capital_hub_admin_session';

@Injectable({ providedIn: 'root' })
export class SessionService {
  save(result: PortalLoginResult): void {
    localStorage.setItem(SESSION_KEY, JSON.stringify(result));
  }

  clear(): void {
    localStorage.removeItem(SESSION_KEY);
  }

  isAuthenticated(): boolean {
    const session = this.current();
    return Boolean(session?.token && session.user?.status === 'active' && !session.user.force_password_change);
  }

  current(): PortalLoginResult | null {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as PortalLoginResult;
    } catch {
      this.clear();
      return null;
    }
  }
}
